import { useContext, useReducer } from 'react'
import { AppContext } from '@/App.context'

export const useRootStore = () => {
  const context = useContext(AppContext)
  return context.store
}

export const useAppContext = () => {
  return useContext(AppContext)
}

export const useAppStore = () => {
  return useRootStore().app
}

export const useUserStore = () => {
  return useRootStore().user
}

export const useRoughStore = () => {
  return useRootStore().rough
}

export const useGraphStore = () => {
  return useRootStore().graph
}

export const useGenStore = () => {
  return useRootStore().gen
}

export const useForceUpdate = () => {
  return useReducer(() => {
    // console.log('force update')
    return {}
  }, {})
}
